import {
  buildOptionsFromData,
  type FilterTableOptionType,
} from '@common/components';

type EmploymentType = { name: string; description: string };

export function handleEmploymentTypeFilter(
  employmentTypesData: { enum: EmploymentType[] } | undefined
) {
  const optionsData = employmentTypesData ? [...employmentTypesData.enum] : [];

  return buildOptionsFromData(
    optionsData,
    ({ description, name }: EmploymentType) => ({
      text: description,
      value: name,
    }),
    ({ name }: EmploymentType) => name,
    (a: FilterTableOptionType, b: FilterTableOptionType) =>
      String(a.text).localeCompare(String(b.text))
  );
}
